import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalTrancheClosed = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      {' '}
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> Closed the accounts tranche: <strong>{event.data.trancheName}</strong>
      </Box>{' '}
    </Box>
  );
};

export default SabalTrancheClosed;
